import React from 'react';

import Logo404 from 'Assets/404_icon.svg';
import Person404 from 'Assets/404_person.svg';

import styles from './InternalErrorPage.module.css';

function InternalErrorPage() {
    // 500 ?

    const navigateBack = () => {
        window.location.href = '/unixi-management-portal/app/dashboard';
    };

    return (
        <main className={styles.page}>
            <div className={styles.content}>
                <img src={Logo404} className={styles.icon} alt='' />
                <img src={Person404} className={styles.person} alt='' />
                <div className={styles.copy}>
                    <div className={styles.heading}>Internal Error</div>
                    Oh no! Something went wrong
                    <br />
                    <b onClick={navigateBack} className={styles.back}>
                        Click here to go back to the login page
                    </b>
                </div>
            </div>
        </main>
    );
}

export default InternalErrorPage;
